module.exports = "../../app/cells/pages/landing_xray/index/card_benefits_cell.rb";